/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const App = require('@gral/app');
const Store = require('../stores/store');
const Immutable = require('immutable');
const k = require('@gral/constants');
const ta_i18n = require('@utils/i18n').default;

// State
let _data = Immutable.Map({
  currentLanguage: null,
  supportedLanguages: ta_i18n.supportedLanguages,
});

class i18nStore extends Store {
  static initClass() {
    this.prototype.storeDomain = 'i18n';
    this.prototype.supportedActions = [k.actionTypes.CHANGE_LANGUAGE, k.actionTypes.SET_CURRENT_LANGUAGE];
  }
  getState() {
    return _data;
  }
  _setCurrentLanguage(action) {
    _data = _data.setIn(['currentLanguage'], action.data.lng);
    return this.emitChange(action);
  }

  _changeLanguage(action) {
    ta_i18n.changeLanguage(action.data.lng);
    return this._setCurrentLanguage(action);
  }
}
i18nStore.initClass();

module.exports = App.i18nStore = new i18nStore();
